import React, { Component } from 'react';
import Tooltip from '@mui/material/Tooltip';
import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJToolTip.module.less';

class FJToolTip extends Component {
    constructor(props = {}) {
        super(props);
        this._enterDelay = typeof props.enterDelay !== 'undefined' ? props.enterDelay : 150;
        this._enterTimerId = null;
        this.state = { open: false };
    }

    componentWillUnmount() {
        this._close();
    }

    close = () => {
        this._close();
    };

    _open = e => {
        if (this.state.open) return;
        if (this._enterTimerId) {
            clearTimeout(this._enterTimerId);
            this._enterTimerId = null;
        }
        this._enterTimerId = setTimeout(() => {
            this._enterTimerId = null;
            this.setState({ open: true });
        }, this._enterDelay);
    };

    _close = e => {
        if (this._enterTimerId) {
            clearTimeout(this._enterTimerId);
            this._enterTimerId = null;
        }
        if (!this.state.open) return;
        this.setState({ open: false });
    };

    _onClick = e => {
        if (this.props.onClick) {
            this.props.onClick(e);
        }
    };

    render() {
        const { title, arrow = true, placement = 'bottom', classes } = this.props;
        const { open } = this.state;

        return title ? (
            <Tooltip
                title={FJLocalStore._(title) || title}
                arrow={arrow}
                placement={placement}
                open={open}
                classes={{
                    tooltip: styles.tooltip,
                    arrow: styles.arrow,
                    ...classes,
                }}
                onMouseOver={this._open}
                onMouseOut={this._close}
                onMouseDownCapture={this._close}
                onClick={this._onClick}
            >
                {this.props.children}
            </Tooltip>
        ) : (
            this.props.children
        );
    }
}

export default FJToolTip;
